export const DESKTOP_BANNER_HEIGHT = 64;
export const DEFAULT_BANNER_HEIGHT = 84;
